









import { Component, Vue } from 'vue-property-decorator'
import CreateKey from '@/components/CreateKey.vue'
import DownloadSeed from '@/components/DownloadSeed.vue'
import Logo from '@/components/Logo.vue'
import { handleError } from '@/error/sentry'

@Component({
  name: 'Register',
  components: { CreateKey, DownloadSeed, Logo }
})
export default class Login extends Vue {
  t (key: string) {
    return this.$t(`Register.${key}`)
  }

  walletSeed = '';
  walletPublicKey = '';
  walletPrivateKey = '';
  currentStep = 0;

  created () {
    this.generateCode()
  }

  async generateCode () {
    try {
      const library = require('@waves/waves-transactions').libs.crypto
      const seed = library.randomSeed(15)
      this.walletSeed = seed
      this.walletPublicKey = library.publicKey(seed)
    } catch (error) {
      handleError(error)
    }
  }
}
